import { ReduxUtils } from 'UI-Dash-Commons-UI';
import * as constants from '../redux/constants';

export const onToggleCodeSnippetBackgroundStyle = ReduxUtils.createAction( constants.ACTION_ON_TOGGLE_CODE_SNIPPET_BACKGROUND_STYLE, 'codeSnippetBackgroundStyle' );
